import { useEffect, useRef, useState } from "react";
import Select from "react-select";
import { AiFillFileAdd } from "react-icons/ai";
import LocalStorageService from "../Auth/auth_service/AuthServiceStorage";
import AxiosService from "../Utils/AxiosService";
import * as Tooltip from "@radix-ui/react-tooltip";
import JsonToTable from "./JsonToTable";
// import Agent from "./formComponents/agent/Agent"; 


/* -----------------------------------------------------------------------
   BOOTSTRAP TOOLTIP OPTION COMPONENT
------------------------------------------------------------------------ */
const apiService = new AxiosService();

export const TooltipOption = ({ data, cvType, context, defaultLanguage }) => {
  const [info, setInfo] = useState(null);

  const fetchInfo = async () => {
    if (!info) {
      try {
        const response = await apiService.completeCVDetail(cvType, data.value);
        setInfo(response.data);
      } catch (error) {
        console.error("Error fetching CV detail:", error);
      }
    }
  };

  const getLabel = () => {
    if (typeof data.label === "string") return data.label;

    if (defaultLanguage?.name && data.label[defaultLanguage.name]) {
      return data.label[defaultLanguage.name];
    }

    return data.label?.ENGLISH || "";
  };

  return (
    <Tooltip.Provider delayDuration={200}>
      <Tooltip.Root>
        <Tooltip.Trigger asChild>
          <div
            onMouseEnter={fetchInfo}
            className="cursor-pointer text-sm text-gray-800 hover:text-blue-600"
          >
            {context === "value" ? (
              <div>{getLabel()}</div>
            ) : typeof data.label === "string" ? (
              <div>{data.label}</div>
            ) : (
              <div>
                {Object.entries(data.label).map(([lang, value]) => (
                  <div key={lang}>
                    <b className="text-xs text-indigo-900">{lang}:</b>{" "}
                    {value}
                  </div>
                ))}
              </div>
            )}
          </div>
        </Tooltip.Trigger>

        {info && (
          <Tooltip.Portal>
            <Tooltip.Content
              side="top"
              sideOffset={8}
              avoidCollisions={true}
              align="start"
              alignOffset={5}
              className="bg-light text-white border border-gray-300 rounded-lg shadow-lg p-2 text-xs max-w-4xl z-100 overflow-y-auto whitespace-normal break-words"
            >
              <JsonToTable data={[info]} defLang={defaultLanguage?.code || ""} />
              <Tooltip.Arrow className="fill-gray-100" />
            </Tooltip.Content>
          </Tooltip.Portal>
        )}
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};

export const CreateFormatOptionLabel = (cvType, defaultLanguage) => {
  return (data, { context }) => (
    <TooltipOption
      data={data}
      cvType={cvType}
      context={context}
      defaultLanguage={defaultLanguage}
    />
  );
};

/* -----------------------------------------------------------------------
                           MAIN COMPONENT
------------------------------------------------------------------------ */

const SingleSelect = ({
  fieldId,
  fieldName,
  fieldType,
  cvType,
  language,
  handleSingleSelectFieldChange,
  fieldValue,
  isFormReset,
  isSaveAccess,
  enableEdit
}) => {
  const [optionData, setOptionData] = useState([]);
  // const [selectedOption, setSelectedOption] = useState(null);
  const [modal, setModal] = useState({ show: false });
  const hasRun = useRef(false);
  // const prevFieldValue = useRef<String | null>(null);
  const prevFieldValue = useRef(null);

    const [selectedOption, setSelectedOption] = useState( null);
  const storageService = LocalStorageService.getService();
  const [defaultLanguage, setDefaultLanguage] = useState(null);

  useEffect(() => {
    setDefaultLanguage(storageService.getDefLanguage());
  }, []);

  //   useEffect(() => {
  //     if (!defaultLanguage) return;
  //   if (fieldValue!=prevFieldValue.current && fieldValue && language) {
  //     searchCV(cvType, fieldValue, defaultLanguage);
  //     prevFieldValue.current=fieldValue;
  //   }
  //   if (!fieldValue || !defaultLanguage || fieldValue==="-") {
  //     setSelectedOption(null);
  //     prevFieldValue.current=null;
  //   }
  //   // else{
  //   //   setselectedOption(null)
  //   //   hasRun.current=false;
  //   // }
  // }, [fieldValue,defaultLanguage]);


  useEffect(() => {
  if (!defaultLanguage) return;

  if (!fieldValue || fieldValue === "-") {
    setSelectedOption(null);
    prevFieldValue.current = null;
    return;
  }

  if (fieldValue !== prevFieldValue.current && language) {
    searchCV(cvType, fieldValue, defaultLanguage);
    prevFieldValue.current = fieldValue;
  }

}, [fieldValue, defaultLanguage, language]);


  useEffect(() => {
    if (!defaultLanguage) return;

    if (!hasRun.current && fieldValue) {
      searchCV(cvType, fieldValue, defaultLanguage);
      hasRun.current = true;
    }
    if (!fieldValue) {
      setSelectedOption(null);
      hasRun.current = false;
    }
  }, [fieldValue,defaultLanguage]);

  const searchCV = (cvType, value, language) => {
    apiService
      .searchCVByKuId(cvType, [value], language)
      .then((resp) => {
        const opts = Object.entries(resp.data).map(([key, value]) => ({
          value: key,
          label: value,
        }));
        setOptionData(opts);
        setSelectedOption(opts[0]);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    if (isFormReset) {
      setSelectedOption(null);
      hasRun.current = false;
    }
  }, [isFormReset]);

  const fetchOptions = (inputValue) => {
    const shouldFetch =
      (cvType === "unit_cv" && inputValue.length >= 1) ||
      (cvType !== "unit_cv" && inputValue.length >= 3);

    if (!shouldFetch) return;

    apiService
      .searchInCVByLabelname(inputValue, cvType, "ES")
      .then((resp) => {
        const opts = Object.entries(resp.data).map(([key, value]) => ({
          value: key,
          label: value,
        }));
        setOptionData(opts);
      })
      .catch(console.log);
  };

  const getFlattenedOptions = (opts) =>
    opts.map((o) => ({
      value: o.value,
      label:
        defaultLanguage?.name && o.label[defaultLanguage.name]
          ? o.label[defaultLanguage.name]
          : o.label.ENGLISH,
    }));

  const handleCVAddition = (kuid) => {
    const kuidList = fieldValue ? [...fieldValue, kuid] : [kuid];

    // apiService
    //   .searchCVByKuId(cvType, kuidList, language)
    //   .then((resp) => {
    //     const options = Object.entries(resp.data).map(([key, value]) => ({
    //       value: key,
    //       label: value,
    //     }));

    //     setOptionData(options);

    //     const flattened = getFlattenedOptions(options);
    //     handleSingleSelectFieldChange(fieldName, flattened[0]);
    //     setSelectedOption(options[0]);
    //   })
    //   .catch(console.log);
  };

  return (
    <div className="mb-3">

      <div className={isSaveAccess ? "d-flex gap-2" : ""}>
        <div className="flex-grow-1">
          <Select
            isDisabled={!enableEdit}
            id={fieldId || fieldName}
            name={fieldName}
            className="w-100"
            options={optionData}
            value={selectedOption}
            onChange={(sel) => {
              setSelectedOption(sel || null);
              const flat = getFlattenedOptions(sel ? [sel] : []);
              handleSingleSelectFieldChange(cvType,fieldId, flat.length > 0 ? flat[0] : null);
            }}
            menuPortalTarget={document.body}
            menuPosition="fixed"
            styles={{
              menuPortal: base => ({ ...base, zIndex: 0 })
            }}
            getOptionLabel={(opt) =>
              opt.label[defaultLanguage] ||
              Object.values(opt.label)[0]
            }
            getOptionValue={(opt) => opt.value}
            onInputChange={fetchOptions}
            placeholder={`Search ${fieldType}...`}
            formatOptionLabel={CreateFormatOptionLabel(
              cvType,
              defaultLanguage
            )}
             isClearable
          />
        </div>

        {isSaveAccess && (
          <button
            className="btn btn-outline-primary"
            title="Add CV"
            onClick={() => setModal({ show: true })}
          >
            <AiFillFileAdd size={22} />
          </button>
        )}
      </div>

      {/* {modal.show && (
        <Agent
          isTableRequired={false}
          handleFormSave={handleCVAddition}
          modal={modal}
          setModal={setModal}
          fieldValue={fieldValue ? [fieldValue] : []}
        />
      )} */}
    </div>
  );
};

export default SingleSelect;
